import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_CONTEXT_REPORT_DATA = 'GET_CONTEXT_REPORT_DATA';
export const GETTING_CONTEXT_REPORT_DATA = 'GETTING_CONTEXT_REPORT_DATA';
export const GETTING_CONTEXT_REPORT_DATA_SUCCEEDED =
  'GETTING_CONTEXT_REPORT_DATA_SUCCEEDED';
export const GETTING_CONTEXT_REPORT_DATA_FAILED =
  'GETTING_CONTEXT_REPORT_DATA_FAILED';
export const GET_CAMPAIGN_REPORT_DATA = 'GET_CAMPAIGN_REPORT_DATA';
export const GETTING_CAMPAIGN_REPORT_DATA = 'GETTING_CAMPAIGN_REPORT_DATA';
export const GETTING_CAMPAIGN_REPORT_DATA_SUCCEEDED =
  'GETTING_CAMPAIGN_REPORT_DATA_SUCCEEDED';
export const GETTING_CAMPAIGN_REPORT_DATA_FAILED =
  'GETTING_CAMPAIGN_REPORT_DATA_FAILED';

export const GET_CAMPAIGN_REPORT_CSV_FILE = 'GET_CAMPAIGN_REPORT_CSV_FILE';
export const GETTING_CAMPAIGN_REPORT_CSV_FILE_SUCCEEDED = 'GETTING_CAMPAIGN_REPORT_CSV_FILE_SUCCEEDED';
export const GETTING_CAMPAIGN_REPORT_CSV_FILE_FAILED = 'GETTING_CAMPAIGN_REPORT_CSV_FILE_FAILED';
export const DOWNLOADED_CAMPAIGN_REPORT_CSV_FILE = 'DOWNLOADED_CAMPAIGN_REPORT_CSV_FILE';

export const SWITCH_CAMPAIGN_REPORT_DATA = 'SWITCH_CAMPAIGN_REPORT_DATA';

export const GET_MESSAGE_HISTORY = 'GET_MESSAGE_HISTORY';
export const GETTING_MESSAGE_HISTORY_SUCCEEDED = 'GETTING_MESSAGE_HISTORY_SUCCEEDED';
export const GETTING_MESSAGE_HISTORY_FAILED = 'GETTING_MESSAGE_HISTORY_FAILED';
export const GET_EMAIL_CLICK_METRICS = 'GET_EMAIL_CLICK_METRICS';
export const GETTING_EMAIL_CLICK_METRICS = 'GETTING_EMAIL_CLICK_METRICS';
export const GETTING_EMAIL_CLICK_METRICS_SUCCEEDED = 'GETTING_EMAIL_CLICK_METRICS_SUCCEEDED';
export const GETTING_EMAIL_CLICK_METRICS_FAILED = 'GETTING_EMAIL_CLICK_METRICS_FAILED';
export const GET_CLICKED_URLS = 'GET_CLICKED_URLS';
export const GETTING_CLICKED_URLS_SUCCEEDED = 'GETTING_CLICKED_URLS_SUCCEEDED';
export const GETTING_CLICKED_URLS_FAILED = 'GETTING_CLICKED_URLS_FAILED';
export const SET_REPORT_QUERY_DATA = 'SET_REPORT_QUERY_DATA';

export const getContextReportData = createAction(GET_CONTEXT_REPORT_DATA);
export const gettingContextReportData = createAction(
  GETTING_CONTEXT_REPORT_DATA
);
export const gettingContextReportDataSucceeded = createAction(
  GETTING_CONTEXT_REPORT_DATA_SUCCEEDED
);
export const gettingContextReportDataFailed = createAction(
  GETTING_CONTEXT_REPORT_DATA_FAILED
);

export const getCampaignReportData = createAction(GET_CAMPAIGN_REPORT_DATA);
export const gettingCampaignReportData = createAction(
  GETTING_CAMPAIGN_REPORT_DATA
);
export const gettingCampaignReportDataSucceeded = createAction(
  GETTING_CAMPAIGN_REPORT_DATA_SUCCEEDED
);
export const gettingCampaignReportDataFailed = createAction(
  GETTING_CAMPAIGN_REPORT_DATA_FAILED
);

export const getCampaignReportCsvFile = createAction(GET_CAMPAIGN_REPORT_CSV_FILE);
export const gettingCampaignReportCsvFileSucceeded = createAction(GETTING_CAMPAIGN_REPORT_CSV_FILE_SUCCEEDED);
export const gettingCampaignReportCsvFileFailed = createAction(GETTING_CAMPAIGN_REPORT_CSV_FILE_FAILED);
export const downloadedCampaignReportCsvFile = createAction(DOWNLOADED_CAMPAIGN_REPORT_CSV_FILE);

export const switchCampaignReportData = createAction(SWITCH_CAMPAIGN_REPORT_DATA);

export const getMessageHistory = createAction('GET_MESSAGE_HISTORY');
export const gettingMessageHistorySucceeded = createAction('GETTING_MESSAGE_HISTORY_SUCCEEDED');
export const gettingMessageHistoryFailed = createAction('GETTING_MESSAGE_HISTORY_FAILED');

export const SET_TENANT_ONLY = 'SET_TENANT_ONLY';
export const setTenantOnly = createAction(SET_TENANT_ONLY);
export const getEmailClickMetrics = createAction(GET_EMAIL_CLICK_METRICS);
export const gettingEmailClickMetrics = createAction(GETTING_EMAIL_CLICK_METRICS);
export const gettingEmailClickMetricsSucceeded = createAction(GETTING_EMAIL_CLICK_METRICS_SUCCEEDED);
export const gettingEmailClickMetricsFailed = createAction(GETTING_EMAIL_CLICK_METRICS_FAILED);
export const getClickedUrls = createAction(GET_CLICKED_URLS);
export const gettingClickedUrlsSucceeded = createAction(GETTING_CLICKED_URLS_SUCCEEDED);
export const gettingClickedUrlsFailed = createAction(GETTING_CLICKED_URLS_FAILED);
export const setReportQueryData = createAction(SET_REPORT_QUERY_DATA);
